import { getCascadeValues } from "../api/Validations";
import { CascadeValue } from "../models/analysiscodes/AnalysisCodes";
import { useWorkOrderStore } from "../store/wo-order";

export const getStoreAccountCascadeValues = async (parentFields: string[]) => {
  //in case offline it will be downloaded and stored inside wo-store
  let cascadeValues: CascadeValue[] | undefined =
    useWorkOrderStore.getState().cascadeValues;
  if (!cascadeValues) {
    const response = await getCascadeValues();
    cascadeValues = response.data;
  }
  let cascadeData: { [key: string]: CascadeValue[] } = {};
  parentFields.forEach((p) => {
    const filteredValues =
      cascadeValues?.filter((validValue) => {
        return getParentFieldMappings(p).some(
          (f) => f.toLowerCase() === validValue.ParentField.toLowerCase()
        );
      }) || [];

    cascadeData = { ...cascadeData, [p]: filteredValues };
  });
  return cascadeData;
};

export const getParentFieldMappings = (field: string) => {
  const fields = [field];
  if (field === "MechanicalIntegrity") fields.push("MechIntegrity");
  else if (field === "MechIntegrity") fields.push("MechanicalIntegrity");
  return fields;
};
